import { atom } from "jotai";

export const solicitudesAusenciaPendientesAprobarAtom = atom([]);
export const visibleModalAprobarSolicitudAusenciaAtom = atom(false);
export const visibleModalRechazarSolicitudAusenciaAtom = atom(false);
export const solicitudAusenciaSeleccionadaAtom = atom(undefined);
export const visibleModalVerDocumentoAdjuntoAtom = atom(false);
export const urlDocumentoAdjuntoAtom = atom("");
export const visibleModalAprobarMasivaSolicitudAusenciaAtom = atom(false);
export const solicitudesAusenciaSeleccionadasAtom = atom([]);
